"use client"

import { useState } from "react"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "#/components/ui/dialog"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "#/components/ui/tabs"
import { Camera, Video, Type, FileText } from "lucide-react"
import { PhotoPostForm } from "./photo-post-form"
import { VideoPostForm } from "./video-post-form"
import { TextPostForm } from "./text-post-form"
import { ArticlePostForm } from "./article-post-form"

interface CreatePostModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onPostCreated?: () => void
}

export function CreatePostModal({
  open,
  onOpenChange,
  onPostCreated,
}: CreatePostModalProps) {
  const [activeTab, setActiveTab] = useState("photo")

  const handlePostCreated = () => {
    onPostCreated?.()
    onOpenChange(false)
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Create New Post</DialogTitle>
        </DialogHeader>
        <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
          <TabsList className="grid w-full grid-cols-4">
            <TabsTrigger value="photo" className="flex items-center gap-2">
              <Camera className="h-4 w-4" />
              Photo
            </TabsTrigger>
            <TabsTrigger value="video" className="flex items-center gap-2">
              <Video className="h-4 w-4" />
              Video
            </TabsTrigger>
            <TabsTrigger value="text" className="flex items-center gap-2">
              <Type className="h-4 w-4" />
              Text
            </TabsTrigger>
            <TabsTrigger value="article" className="flex items-center gap-2">
              <FileText className="h-4 w-4" />
              Article
            </TabsTrigger>
          </TabsList>
          <TabsContent value="photo" className="mt-6">
            <PhotoPostForm onPostCreated={handlePostCreated} />
          </TabsContent>
          <TabsContent value="video" className="mt-6">
            <VideoPostForm onPostCreated={handlePostCreated} />
          </TabsContent>
          <TabsContent value="text" className="mt-6">
            <TextPostForm onPostCreated={handlePostCreated} />
          </TabsContent>
          <TabsContent value="article" className="mt-6">
            <ArticlePostForm onPostCreated={handlePostCreated} />
          </TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  )
}
